import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Button, Grid } from '@material-ui/core';
import { ServiceValues } from '../../../../../values/ServiceValues';
import { ServiceAxios } from '../../../../../services/ServiceEW';
import { useStyles } from './ModalidadeDetalhesStyles';
import Typography from '@material-ui/core/Typography';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import ExpansionPanel from '@material-ui/core/ExpansionPanel';
import ExpansionPanelSummary from '@material-ui/core/ExpansionPanelSummary';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ExpansionPanelDetails from '@material-ui/core/ExpansionPanelDetails';
import Autocomplete from '@material-ui/lab/Autocomplete';
import TextField from '@material-ui/core/TextField';
import Switch from '@material-ui/core/Switch';
import Alert from '@material-ui/lab/Alert';
import CurrencyTextField from '@unicef/material-ui-currency-textfield';
import ExpansionPanelActions from '@material-ui/core/ExpansionPanelActions';
import { putVisitaFiliadoDisp } from '../../../../../services/VisitaFiliadoDispService';
import { Values } from '../../../../../values/Values';
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';


function ModalidadeDetalhes(props) {
  const {
    expandedDetalhes,
    setExpandedDetalhes,
    visitaFiliado,
    setVisitaFiliado,
    indexModalidade,
    setShowMessageSnack,
    setMessageSnack,
    setTypeSnack,
    setLoading,
    armas,
    insumos,
    pacotes
  } = props;

  const classes = useStyles();
  const [refreshState, setRefreshState] = useState(new Date());

  const expandRodada = panel => (event, isExpanded) => {
    setExpandedDetalhes(isExpanded ? panel : false);
  };

  function handleChangeCheckArmaPropria() {
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].armaPropria =
      !visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].armaPropria;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].arma = null;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].notaFiscal = null;
    setVisitaFiliado(visitaFiliado);
    setRefreshState(new Date);

  }

  function handleChangeCheckInsumoProprio() {
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].insumoProprio =
      !visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].insumoProprio;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorDisparo = 0;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].insumo = null;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].notaFiscalInsumo = null;
    if(!visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].pacote){
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal = 0;
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].desconto = 0;
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].quantidade = 0;
    }
    setVisitaFiliado(visitaFiliado);
    setRefreshState(new Date);


  }

  function handleChangeCheckUtilizaPacote() {
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote =
      !visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].idPacote = null;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].idArma = null;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].idInsumo = null;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].quantidade = 0;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorDisparo = 0;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal = 0;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].desconto = 0;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].pacote = null;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].arma = null;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].insumo = null;
    setVisitaFiliado(visitaFiliado);
    setRefreshState(new Date);

  }

  function handleChangePacote(event, pacote) {
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].pacote = pacote;
    if(pacote){
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].idPacote = pacote.idPacote;
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].quantidade = pacote.quantidadeDisparos;
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorDisparo = 0;
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal = pacote.valor;
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal =
        visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal -
        visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].desconto;
    }
    else {
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].idPacote = null;
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].quantidade = 0;
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorDisparo = 0;
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal = 0;
    }
    setVisitaFiliado(visitaFiliado);
    setRefreshState(new Date());
  }

  function handleChangeQuantidade(qtd) {

    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].quantidade = qtd;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal = qtd * visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorDisparo;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal =
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal -
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].desconto;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal = tratarValorTotal(visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal);
    setVisitaFiliado(visitaFiliado);
    setRefreshState(new Date());
  }

  function aoModificarNumeroNotaFiscal(event, value) {
    event.preventDefault();
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].notaFiscal = value;
    setVisitaFiliado(visitaFiliado);
    setRefreshState(new Date());
  }

  function aoModificarNumeroNotaFiscalInsumo(event, value) {
    event.preventDefault();
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].notaFiscalInsumo = value;
    setVisitaFiliado(visitaFiliado);
    setRefreshState(new Date());
  }

  function handleChangeDesconto(desconto) {
    if(visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote){
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal = visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].pacote.valor
    }
    else{
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal =
        visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].quantidade * visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorDisparo;
    }
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].desconto = desconto;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal =
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal - desconto;
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal = tratarValorTotal(visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal);

    setVisitaFiliado(visitaFiliado);
    setRefreshState(new Date());
  }

  function handleChangeArma(event, arma) {
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].arma = arma;
    if(arma){
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].idArma = arma.idArma;
    }
    else {
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].idArma = null;
    }
    setVisitaFiliado(visitaFiliado);
    setRefreshState(new Date());
  }

  function handleChangeInsumo(event, insumo) {
    visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].insumo = insumo;
    if(insumo){
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].idInsumo = insumo.idInsumo;
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorDisparo = insumo.valorVenda;
      if(!visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].pacote){
        visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorDisparo = insumo.valorVenda;
      }
      else{
        visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorDisparo = 0;
      }
    }
    else {
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].idInsumo = null;
      visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorDisparo = 0;

    }
    setVisitaFiliado(visitaFiliado);
    setRefreshState(new Date());
  }

  async function enviarRegistroDisp(event, update) {
    try {
      setLoading(true);
      let resultPutVisitaFiliadoDisp = await putVisitaFiliadoDisp(visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0]);
      if(resultPutVisitaFiliadoDisp.isSuccess){
        setLoading(false);
        setTypeSnack('success');
        setMessageSnack('Detalhes atualizados com sucesso.');
        setShowMessageSnack(true);
      }
      else{
        setLoading(false);
        setTypeSnack('error');
        setMessageSnack(resultPutVisitaFiliadoDisp.message);
        setShowMessageSnack(true);
      }

    } catch (e) {
      setTypeSnack('error');
      setMessageSnack(Values.MessageValues.erro_catch + ' ERROR: ' + e.toString());
      setShowMessageSnack(true);
      setLoading(false);
    }
  }

  function tratarValorTotal(valorTotal) {
    return valorTotal && valorTotal >= 0 ? valorTotal : 0;
  }


  return (
    <Grid
      container
    >
      <Grid
        item
        md={12}
        xs={12}
      >
        <ExpansionPanel
          variant={'outlined'}
          expanded={expandedDetalhes === ('panel1')} onChange={expandRodada('panel1')}>
          <ExpansionPanelSummary
            expandIcon={<ExpandMoreIcon />}
            aria-controls="panel1bh-content"
            id="panel1bh-header"
          >
            <Typography className={classes.heading}>{"Detalhes"}</Typography>
            <Typography className={classes.secondaryHeading}>{'Detalhes da modalidade (arma, pacote, insumo e valores)'}</Typography>
          </ExpansionPanelSummary>
          <ExpansionPanelDetails>
            <Grid
              container
              spacing={2}
            >
              <Grid
                item
                md={4}
                xs={12}
              >
                <FormControlLabel
                  control={<Switch checked={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote} color='primary' onChange={handleChangeCheckUtilizaPacote} name="checkUtilizaPacote" />}
                  label="Utilizar Pacote"
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
              >
                <FormControlLabel
                  control={<Switch checked={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].armaPropria} color='primary' onChange={handleChangeCheckArmaPropria} name="armaPropria" />}
                  label="Arma própria"
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
              >
                <FormControlLabel
                  control={<Switch checked={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].insumoProprio} color='primary' onChange={handleChangeCheckInsumoProprio} name="insumoProprio" />}
                  label="Insumo Próprio"
                />
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
              >
                {
                  !visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote ?
                    <Alert severity="info">Utilização de pacote não se aplica a esta visita.</Alert>
                    :
                    <Autocomplete
                      id="pacote"
                      options={pacotes.result}
                      getOptionLabel={option => option.descricao}
                      value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].pacote}
                      onChange={handleChangePacote}
                      renderInput={params =>
                        <TextField
                          {...params}
                          label="Pacote"
                          variant="outlined"
                          fullWidth
                          margin='dense'
                          helperText='Informe o pacote desejado.'
                        />
                      }
                    />
                }
              </Grid>
              <Grid
                item
                md={4}
                xs={12}
              >
                {
                  visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].armaPropria ?
                    <TextField
                      label="Nº CRAF"
                      helperText='Informe o Nº CRAF da arma que o filiado utilizará.'
                      variant="outlined"
                      fullWidth
                      margin='dense'
                      type='text'
                      value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].notaFiscal}
                      onChange={e => aoModificarNumeroNotaFiscal(e, e.target.value)}
                    />
                    :
                    <Autocomplete
                      id="arma-propria"
                      options={armas.result}
                      value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].arma}
                      getOptionLabel={option => option.descricao}
                      onChange={handleChangeArma}
                      renderInput={params =>
                        <TextField
                          {...params}
                          label="Arma"
                          variant="outlined"
                          fullWidth
                          margin='dense'
                          helperText='Informe a arma desejada.'
                        />
                      }
                    />
                }
              </Grid>

              <Grid
                item
                md={4}
                xs={12}
              >
                {
                  visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].insumoProprio ?
                    <TextField
                      label="Nº nota fiscal"
                      helperText='Informe o Nº da nota fiscal do insumo que o filiado utilizará.'
                      variant="outlined"
                      fullWidth
                      margin='dense'
                      type='text'
                      value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].notaFiscalInsumo}
                      onChange={e => aoModificarNumeroNotaFiscalInsumo(e, e.target.value)}
                    />
                    :
                    <Autocomplete
                      id="combo-box-demo"
                      options={insumos.result}
                      getOptionLabel={option => option.descricao}
                      value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].insumo}
                      onChange={handleChangeInsumo}
                      renderInput={params =>
                        <TextField
                          {...params}
                          label="Insumo"
                          variant="outlined"
                          fullWidth
                          margin='dense'
                          helperText='Informe o insumo desejado.'
                        />
                      }
                    />
                }
              </Grid>
              {
                !visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote &&
                <Grid
                  item
                  md={3}
                  xs={12}
                >
                  {
                    <CurrencyTextField
                      label="Valor unitário"
                      helperText='Valor unitário de cada disparo.'
                      variant="outlined"
                      currencySymbol="R$"
                      minimumValue="0"
                      outputFormat="number"
                      decimalCharacter=","
                      digitGroupSeparator='.'
                      fullWidth
                      disabled
                      margin='dense'
                      value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorDisparo}
                    />
                  }
                </Grid>
              }

              <Grid
                item
                md={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote ? 4 : 3}
                xs={12}
              >
                <TextField
                  label="Quantidade"
                  helperText='Quantidade de disparos fornecidos.'
                  variant="outlined"
                  fullWidth
                  margin='dense'
                  type='number'
                  disabled={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote}
                  value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].quantidade}
                  onChange={e => handleChangeQuantidade(e.target.value)}
                />
              </Grid>
              <Grid
                item
                md={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote ? 4 : 3}
                xs={12}
              >
                <CurrencyTextField
                  label="Desconto"
                  helperText='Informe um valor, caso queira aplicar algum desconto.'
                  variant="outlined"
                  currencySymbol="R$"
                  minimumValue="0"
                  outputFormat="number"
                  decimalCharacter=","
                  digitGroupSeparator='.'
                  fullWidth
                  value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].desconto}
                  onChange={(event, value) => handleChangeDesconto(value)}
                  margin='dense'
                />
              </Grid>
              <Grid
                item
                md={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].utilizaPacote ? 4 : 3}
                xs={12}
              >
                <CurrencyTextField
                  label="Valor total"
                  helperText='Valor contabilizando valor unitário, quantidade e desconto nos disparos.'
                  variant="outlined"
                  currencySymbol="R$"
                  minimumValue="0"
                  outputFormat="number"
                  decimalCharacter=","
                  digitGroupSeparator='.'
                  fullWidth
                  margin='dense'
                  disabled
                  value={visitaFiliado.visitaFiliadoMods[indexModalidade].visitaFiliadoDisps[0].valorTotal}
                />
              </Grid>

            </Grid>
          </ExpansionPanelDetails>
          <ExpansionPanelActions>
            <Button
              variant="text"
              color={'primary'}
              onClick={e => enviarRegistroDisp(e, true)}
              startIcon={<CheckCircleOutlineIcon />}
            >
              ATUALIZAR DETALHES
            </Button>
          </ExpansionPanelActions>

        </ExpansionPanel>
      </Grid>
    </Grid>
  );
}

ModalidadeDetalhes.propTypes = {
  className: PropTypes.string,
  visitaFiliado: PropTypes.object.isRequired,
  setVisitaFiliado: PropTypes.object.isRequired
};

export default ModalidadeDetalhes;


